import styled from 'styled-components'

export const ModelSection = styled.div`
  display: flex;
  flex-direction: column;
`

export const DropdownWrapper = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 16px;
  gap: 12px;

  .model-dropdown {
    height: 36px;
  }
`

export const ModelOptionsWrapper = styled.div`
  display: flex;
  gap: 10px;

  .option-dropdown {
    height: 36px;
  }
`

export const ScopeCheckboxWrapper = styled.div`
  .scope-checkbox-label {
    font-size: 14px;
    font-weight: 500;
  }

  .scope-checkbox-label p {
    font-size: inherit;
  }
`
